import React from "react";
import { Formik, FormikBag } from "formik";
import { styled } from "@material-ui/core";
import Container from "components/design-system/templates/Container";
import LoginCard from "components/HomeRepairVisitManagement/loginCard/LoginCard";
import Title1 from "components/design-system/atoms/Typography/Title1";
import Box from "@material-ui/core/Box";
import BodyLarge from "components/design-system/atoms/Typography/BodyLarge";
import { HomeRepairCredentials } from "types/HomeRepairCredentials";
import useHomeRepairAuth from "hooks/useHomeRepairAuth";

import * as Yup from "yup";

const HomeRepairCredentialsSchema = Yup.object().shape({
  lastname: Yup.string()
    .required("Merci de remplir ce champ")
    .min(2, "Minimum 2 caractères")
    .test({
      name: "lastname",
      test: (value) => {
        const lastName = value && value.replace(/\s/g, "");
        return [2, 3].includes(lastName?.length);
      },
      message: "Maximum 3 caractères",
    }),

  file_number: Yup.string()
    .required("Merci de remplir ce champ")
    .matches(/^\d{6}_\d{6}$/, "Format incorrect. Exemple : 200001_200001 "),
});

// We can't use typography here due to material v4 component prop being
// broken
const GlobalFormErrorMessage = styled("div")(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "18px",
  textAlign: "center",
  width: "336px",
  color: "#FF757B",
  marginTop: `${theme.spacing(2)}px`,
}));

const HomeRepairLoginForm: React.FunctionComponent = () => {
  const { login } = useHomeRepairAuth();
  const handleSubmit = async (
    credentials: HomeRepairCredentials,
    formikBag: FormikBag<Record<string, unknown>, HomeRepairCredentials>
  ) => {
    try {
      await login(credentials);
      formikBag.setStatus({
        credentialsError: false,
      });
    } catch {
      formikBag.setStatus({
        credentialsError: true,
      });
    }
  };

  const InitialValues = {
    file_number: "",
    lastname: "",
  };
  return (
    <>
      <Formik
        initialStatus={{ credentialsError: false }}
        onSubmit={handleSubmit}
        initialValues={InitialValues}
        validationSchema={HomeRepairCredentialsSchema}
      >
        {({ status }) => (
          <>
            <Container paddingTop={3} paddingBottom={7} variant="pink">
              <Box marginBottom={1}>
                <Title1 align="center">Gérer votre rendez-vous</Title1>
              </Box>
              <BodyLarge color="secondary" textAlign="center">
                Consultez les détails, modifiez ou annulez votre rendez-vous
              </BodyLarge>
            </Container>
            <Container flexDirection="column" display="flex" justifyContent="center" alignItems="center">
              <Box
                maxWidth="400px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                position="relative"
                top="-24px"
              >
                <LoginCard />
                {status.credentialsError && (
                  <GlobalFormErrorMessage>
                    Ces informations ne permettent pas d’identifier un rendez-vous. Vérifiez les informations ou
                    contactez notre service client
                  </GlobalFormErrorMessage>
                )}
              </Box>
            </Container>
          </>
        )}
      </Formik>
    </>
  );
};

export default HomeRepairLoginForm;
